import { StyleSheet, View } from 'react-native';

import Badge from '../../Components/Badge';
import { HintProps } from '../../Components/Hint';
import themeStyle from '../../Theme/styles';

import MealPlanHint, { HintKey } from './MealPlanHint';

const ExclusiveSectionBadge = ({
  isExclusive,
  scrollOffset,
  scrollRef,
}: {
  isExclusive: boolean;
  scrollOffset?: number;
  scrollRef: HintProps['scrollRef'];
}) => {
  if (!isExclusive) return null;
  return (
    <View style={themeStyle.spacingLeftMedium}>
      <MealPlanHint
        hintKey={HintKey.EXCLUSIVE}
        scrollOffset={scrollOffset}
        scrollRef={scrollRef}
      >
        <Badge
          category={Badge.CATEGORIES.INFO}
          numberOfLines={1}
          size="c1"
          style={styles.fixedWidth}
          type={Badge.TYPES.OUTLINE}
        >
          EXCLUSIVE
        </Badge>
      </MealPlanHint>
    </View>
  );
};

const styles = StyleSheet.create({
  fixedWidth: {
    width: 73,
  },
});

export default ExclusiveSectionBadge;
